import request from '../request';

export type DynamicPropertyType = string;

export type DynamicPropertyOptionItem =
  | 'required'
  | {
      type: 'enum';
      values: (string | number | boolean)[];
    };

export interface DynamicProperty {
  type: DynamicPropertyType;
  name: string;
  label: string;
  options?: DynamicPropertyOptionItem[];
}

export type DynamicObjectValues = Record<string, unknown>;

export interface DynamicObjectDefinition {
  properties: DynamicProperty[];
  values?: DynamicObjectValues;
}

export interface DynamicTemplateConfig {
  extends: string;
  with?: Omit<DynamicObjectDefinition, 'values'>;
  values?: DynamicObjectValues;
}

export type DynamicTemplate = string | DynamicTemplateConfig;

export interface DynamicObjectCreateFieldsByObject {
  object: DynamicObjectDefinition;
}

export interface DynamicObjectCreateFieldsByTemplate {
  template: DynamicTemplate;
}

export type DynamicObjectCreateFields =
  | DynamicObjectCreateFieldsByObject
  | DynamicObjectCreateFieldsByTemplate;

export interface DynamicObjectCreateParams {
  fields: DynamicObjectCreateFields;
}

export interface DynamicObjectResult {
  id: string;
  object: DynamicObjectDefinition;
}

export type DynamicObjectCreateResponse = DynamicObjectResult;

export interface DynamicObjectUpdateFields {
  object: DynamicObjectDefinition;
}

export interface DynamicObjectUpdateParams {
  id: string;
  fields: DynamicObjectUpdateFields;
}

export type DynamicObjectUpdateResponse = DynamicObjectResult;

export interface DynamicObjectGetParams {
  id: string;
}

export type DynamicObjectGetResponse = {
  id: string;
 label: string|null;
} & DynamicObjectDefinition;

export interface DynamicObjectDeleteParams {
  id: string;
}

export type DynamicObjectDeleteResponse = boolean;

export interface DynamicObjectSetValuesParams {
  id: string;
  values: DynamicObjectValues;
}

export type DynamicObjectSetValuesResponse = DynamicObjectResult;

export const dynamicObjectCreate = request<
  DynamicObjectCreateResponse,
  DynamicObjectCreateParams
>({
  method: 'dynamicObject.create',
});

export const dynamicObjectUpdate = request<
  DynamicObjectUpdateResponse,
  DynamicObjectUpdateParams
>({
  method: 'dynamicObject.update',
});

export const dynamicObjectGet = request<
  DynamicObjectGetResponse,
  DynamicObjectGetParams
>({
  method: 'dynamicObject.get',
});

export const dynamicObjectDelete = request<
  DynamicObjectDeleteResponse,
  DynamicObjectDeleteParams
>({
  method: 'dynamicObject.delete',
});

export const dynamicObjectSetValues = request<
  DynamicObjectSetValuesResponse,
  DynamicObjectSetValuesParams
>({
  method: 'dynamicObject.setValues',
});


